import * as i0 from '@angular/core';
import { Injectable, PLATFORM_ID, Inject, makeStateKey, Input, Component, NgModule } from '@angular/core';
import * as i2$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import { throwError, of } from 'rxjs';
import { map, catchError, mergeMap, timeout, flatMap, tap, finalize } from 'rxjs/operators';
import * as i2 from '@citi-gcg-173875/citi-utils';
import { StorageService, WINDOW } from '@citi-gcg-173875/citi-utils';
import * as i1 from '@angular/common/http';
import { HttpParams, HttpHeaders, HttpResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { isPlatformServer, CommonModule } from '@angular/common';
import { saveAs } from 'file-saver';
import * as rs from 'jsrsasign';
import * as CryptoJS_EncHex from 'crypto-js/enc-hex';
import { encrypt, decrypt } from 'crypto-js/aes';
import * as CryptoJS_NoPad from 'crypto-js/pad-nopadding';
import Utf8 from 'crypto-js/enc-utf8';
import { Cookie } from 'ng2-cookies';

class HttpConfigService {
    constructor(_appConfigService, _storageService) {
        this._appConfigService = _appConfigService;
        this._storageService = _storageService;
        this.newSessionDeleteLogic = false;
        this.newSessionDeleteLogic = !!this._appConfigService.getSessionDeleteFlagConfig();
    }
    static coerceHeders(headers) {
        if (headers) {
            for (let [key, val] of Object.entries(headers)) {
                if (typeof val === "number") {
                    throw new Error("Header values cannot be number");
                }
            }
        }
        return;
    }
    getOptions(options) {
        options = options || {};
        if (options.headers) {
            HttpConfigService.coerceHeders(options.headers);
        }
        // tslint:disable-next-line:forin
        let params = new HttpParams({ fromObject: options.params });
        // Set defaultHeaders
        let defaultHeaders = this._appConfigService.getHttpServiceConfig()
            .defaultHeaders; //TODO:  this will cause problems trying to tie into the mobile/browser integration project...
        let headersObj = {};
        options.headers = options.headers || {};
        Object.assign(headersObj, defaultHeaders);
        Object.assign(headersObj, options.headers);
        // Set headers taking the values from previous response headers
        let headersVar = !this.newSessionDeleteLogic ? this._appConfigService.getHttpServiceConfig().headersToSendFromPreviousResponse
            : this._appConfigService.getHttpServiceConfig().headersToSendFromPreviousResponsenewlogic;
        if (headersVar) {
            for (let headerInfo of headersVar) {
                let value = this._storageService.get(headerInfo.headerNameInPreviousResponse);
                if (value) {
                    if (headerInfo.headerNameInPreviousResponse == 'Authorization') {
                        // console.log('inside Authorization');
                        value = 'Bearer ' + value;
                    }
                    headersObj[headerInfo.headerNameToSendInRequest] = value;
                }
            }
        }
        // Set headers taking the values from cookies
        if (this._appConfigService.getSessionCookieInformation().cookieName &&
            this._storageService.get(this._appConfigService.getSessionCookieInformation().cookieName)) {
            let cookieName = this._appConfigService.getSessionCookieInformation()
                .cookieName;
            let valueSeparator = this._appConfigService.getSessionCookieInformation()
                .valueSeparator;
            if (cookieName) {
                let arrValues = this._storageService.getArray(cookieName, valueSeparator, StorageService.COOKIE);
                if (this._appConfigService.getSessionCookieInformation().headers) {
                    for (let header of this._appConfigService.getSessionCookieInformation()
                        .headers) {
                        let headerValue = this.getHeaderValue(arrValues, header.headerValue);
                        if (headerValue) {
                            headersObj[header.headerName] = headerValue;
                        }
                    }
                }
            }
        }
        let headers = new HttpHeaders();
        headersObj = this.removeNullHeader(headersObj);
        for (let head in headersObj) {
            headers = headers.append(head, headersObj[head]);
        }
        headers = headers.set('Accept-language', this._appConfigService.getLocale());
        let requestOptions = {
            headers: headers,
            params: params,
            withCredentials: true
            // observe: <const>this.getOptionsObject(options.contentRequest)
        };
        Object.assign(requestOptions, {
            observe: this.getOptionsObject(options.contentRequest)
        });
        if (options.responseType) {
            requestOptions['responseType'] = options.responseType;
        }
        if (options.observe)
            requestOptions['observe'] = options.observe;
        // console.log('requestOptions -------> ', requestOptions);
        return requestOptions;
    }
    getOptionsObject(flag) {
        return !!flag ? 'body' : 'response';
    }
    getHeaderValue(arrValues, headerValueExp) {
        let tagArray = /\[\w{1,}\]/.exec(headerValueExp);
        if (tagArray && tagArray.length > 0) {
            let tag = tagArray[0].replace('[', '').replace(']', '');
            if (arrValues != null && arrValues.length > 0) {
                for (let tagValue of arrValues) {
                    if (tagValue.indexOf(tag + '=') > -1) {
                        return headerValueExp.replace('[' + tag + ']', tagValue.replace(tag + '=', ''));
                    }
                }
            }
        }
        return null;
    }
    removeNullHeader(headers) {
        let newHeaders = {};
        for (let header in headers) {
            if (headers[header]) {
                newHeaders[header] = headers[header];
            }
        }
        return newHeaders;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HttpConfigService, deps: [{ token: i2.AppConfigService }, { token: i2.StorageService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HttpConfigService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HttpConfigService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i2.AppConfigService }, { type: i2.StorageService }] });

class ContentStorageService {
    constructor() {
        //  previously  private _content:any = {};
        this._content = {};
        this._cache = {};
    }
    set(appId, content) {
        if (this._content[appId]) {
            let data1 = this._content[appId];
            let data2 = content;
            let data3 = this.mergeRecursive(data1, data2);
            let finalData = this.mergeDynamcicContentData(data3);
            this._content[appId] = finalData;
        }
        else {
            this._content[appId] = content;
        }
        this._cache[appId] = {};
    }
    getKeys(data) {
        let keys = [];
        if (typeof data !== 'undefined') {
            let nodes = data.split('.');
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < nodes.length; i++) {
                keys.push(nodes[i]);
            }
        }
        return keys;
    }
    getCacheKey(contentType, contentId, prop, placeholdersObj) {
        let key = contentType + '_' + contentId;
        if (typeof prop !== 'undefined') {
            key = key + '_' + prop;
        }
        if (typeof placeholdersObj !== 'undefined') {
            // tslint:disable-next-line:forin
            for (let objProp in placeholdersObj) {
                key = key + '_' + objProp + '_' + placeholdersObj[objProp];
            }
        }
        return key;
    }
    get(appId, contentType, contentId, prop, placeholdersObj) {
        let cacheKey = this.getCacheKey(contentType, contentId, prop, placeholdersObj);
        if (this._cache[appId] && this._cache[appId][cacheKey]) {
            return this._cache[appId][cacheKey];
        }
        if (this._content[appId]) {
            if (this._content[appId][contentType + '$$' + contentId]) {
                if (typeof prop === 'undefined') {
                    return this._content[appId][contentType + '$$' + contentId];
                }
                let content, contentObj;
                let keys = this.getKeys(prop);
                if (keys.length > 1) {
                    try {
                        contentObj = JSON.parse(this._content[appId][contentType + '$$' + contentId][keys[0]]);
                    }
                    catch (e) {
                        contentObj = this._content[appId][contentType + '$$' + contentId][keys[0]];
                    }
                    for (let i = 1; i < keys.length; i++) {
                        if (typeof contentObj !== 'undefined' &&
                            contentObj != null &&
                            contentObj[keys[i]]) {
                            try {
                                contentObj = JSON.parse(contentObj[keys[i]]);
                            }
                            catch (e) {
                                contentObj = contentObj[keys[i]];
                            }
                        }
                        else {
                            contentObj = undefined;
                        }
                    }
                    content = contentObj;
                }
                else {
                    contentObj = this._content[appId][contentType + '$$' + contentId][prop];
                    try {
                        content = JSON.parse(contentObj);
                    }
                    catch (e) {
                        // Is not a json object, it means it is a string
                        content = contentObj;
                    }
                }
                if (placeholdersObj && typeof content === 'string') {
                    let placeholderArr = Object.keys(placeholdersObj);
                    for (let placeholder of placeholderArr) {
                        content = content.replace('{{' + placeholder + '}}', placeholdersObj[placeholder]);
                    }
                }
                this._cache[appId][cacheKey] = content;
                return content;
            }
        }
        return undefined;
    }
    getByAppId(appId) {
        return this._content[appId];
    }
    mergeRecursive(obj1, obj2) {
        // iterate over all the properties in the object which is being consumed
        for (let p in obj2) {
            if (obj1.hasOwnProperty(p) && typeof obj1[p] === 'object') {
                obj1[p] = this.mergeRecursive(obj1[p], obj2[p]);
            }
            else {
                obj1[p] = obj2[p];
            }
        }
        return obj1;
    }
    mergeDynamcicContentData(dat) {
        let result = {}; // This will be the merged object
        let keys = Object.keys(dat); // Contains keys
        while (keys.length) {
            let i = 1;
            for (; i < keys.length; i++) {
                // Find matches
                if (keys[0] == keys[i] + '$$$d') {
                    // Match type 1
                    result[keys[i]] = dat[keys[i]]; // Copy orig
                    // tslint:disable-next-line:forin
                    for (let j in dat[keys[0]]) {
                        // Replace values
                        result[keys[i]][j] = dat[keys[0]][j];
                    }
                    keys.splice(i, 1);
                    keys.shift();
                    i = 0;
                    break;
                }
                else if (keys[i] == keys[0] + '$$$d') {
                    // Reverse matched
                    result[keys[0]] = dat[keys[0]];
                    // tslint:disable-next-line:forin
                    for (let j in dat[keys[i]]) {
                        result[keys[0]][j] = dat[keys[i]][j];
                    }
                    keys.splice(i, 1);
                    keys.shift();
                    i = 0;
                    break;
                }
            }
            if (i > 0) {
                // Didn't find a match
                result[keys[0]] = dat[keys[0]];
                keys.shift();
            }
        }
        return result;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentStorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentStorageService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentStorageService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

class ContentStaticService {
    constructor(_httpClient, _appConfigService, _httpConfigService, _contentStorageService, _transferState, _platformId, _window) {
        this._httpClient = _httpClient;
        this._appConfigService = _appConfigService;
        this._httpConfigService = _httpConfigService;
        this._contentStorageService = _contentStorageService;
        this._transferState = _transferState;
        this._platformId = _platformId;
        this._window = _window;
        this.businessLogic = this._appConfigService.getBusinessId();
    }
    getStaticMetadata() {
        const self = this;
        return this._httpClient
            .get(this.buildStaticMetadataUrl(), this._httpConfigService.getOptions({ contentRequest: true }))
            .pipe(map(res => {
            if (res === '') {
                self._metadata = {};
            }
            else {
                self._metadata = res;
            }
            return self._metadata;
        }), catchError((error) => {
            self._metadata = {};
            return throwError(error);
        }));
    }
    getStaticBundle(appId, customBusinessLogic) {
        const self = this;
        if (this._appConfigService.getContentServiceConfig().useHashForSC &&
            (this._metadata === undefined || this._metadata === null)) {
            return this.getStaticMetadata().pipe(mergeMap(metadataRes => {
                return this._httpClient
                    .get(this.buildStaticBundleUrl(appId, customBusinessLogic), this._httpConfigService.getOptions({ contentRequest: true }))
                    .pipe(map(res => this.staticBundleHandler(res, appId)), catchError((error) => {
                    return throwError(error);
                }));
            }), catchError((error) => {
                return this._httpClient
                    .get(this.buildStaticBundleUrl(appId, customBusinessLogic), this._httpConfigService.getOptions({ contentRequest: true }))
                    .pipe(map(res => this.staticBundleHandler(res, appId)), catchError((error) => {
                    return throwError(error);
                }));
            }));
        }
        else {
            return this._httpClient
                .get(this.buildStaticBundleUrl(appId, customBusinessLogic), this._httpConfigService.getOptions({ contentRequest: true }))
                .pipe(map(res => this.staticBundleHandler(res, appId)), catchError((error) => {
                return throwError(error);
            }));
        }
    }
    staticBundleHandler(res, appId) {
        let staticdata;
        if (res === '') {
            staticdata = {};
        }
        else {
            staticdata = res;
        }
        let data = {};
        if (staticdata['content']) {
            data = staticdata['content'][appId];
        }
        this._contentStorageService.set(appId, data);
        return this._contentStorageService.getByAppId(appId);
    }
    getPageDef(appId, viewId) {
        const self = this;
        return this._httpClient.get(this.buildStaticPageDefUrl(appId, viewId)).pipe(map(res => {
            let pageDefData;
            if (res === '') {
                pageDefData = {};
            }
            else {
                pageDefData = res;
            }
            let data = {};
            if (pageDefData['content']) {
                data = pageDefData['content'][appId];
            }
            self._contentStorageService.set(appId, data);
            return self._contentStorageService.get(appId, 'page_def', viewId);
        }), catchError((error) => {
            return throwError(error);
        }));
    }
    getStaticResource(path) {
        let fileName = path.split('/')[path.split('/').length - 1];
        return this._httpClient
            .get(this.buildStaticResourceUrl(path), { responseType: 'blob' })
            .pipe(catchError((error) => {
            return throwError(error);
        }))
            .subscribe(blob => saveAs(blob, fileName));
    }
    buildStaticMetadataUrl() {
        let completeStaticUrl = this.getStaticBaseUrl() +
            '/staticcms/' +
            this._appConfigService.getBusinessId() +
            '/' +
            this._appConfigService.getLocale() +
            '/metadata/metadata.json';
        return completeStaticUrl;
    }
    buildStaticBundleUrl(appId, customBusinessLogic) {
        if (customBusinessLogic) {
            this.businessLogic = customBusinessLogic;
        }
        else if (!customBusinessLogic && this.businessLogic == 'USMKT') {
            this.businessLogic = 'USGCB';
        }
        let completeStaticUrl = this.getStaticBaseUrl() +
            '/staticcms/' +
            this.businessLogic +
            '/' +
            this._appConfigService.getLocale() +
            '/appid/';
        if (this._appConfigService.getContentServiceConfig().useHashForSC &&
            typeof this._metadata === 'object') {
            let hash = this._metadata[appId];
            if (hash) {
                completeStaticUrl = completeStaticUrl + hash + '/';
            }
        }
        completeStaticUrl = completeStaticUrl + appId + '.json';
        return completeStaticUrl;
    }
    buildStaticPageDefUrl(appId, viewId) {
        let completeStaticUrl = this.getStaticBaseUrl() +
            '/staticcms/' +
            this._appConfigService.getBusinessId() +
            '/' +
            this._appConfigService.getLocale() +
            '/' +
            appId +
            '/pagedef/' +
            viewId +
            '.json';
        return completeStaticUrl;
    }
    buildStaticResourceUrl(path) {
        let completeStaticUrl = this.getStaticBaseUrl() +
            '/staticcms/' +
            this._appConfigService.getBusinessId() +
            '/' +
            path;
        return completeStaticUrl;
    }
    getStaticBaseUrl() {
        let baseUrl = '';
        if (this._appConfigService.getApiServerUrl()) {
            baseUrl = this._appConfigService.getApiServerUrl();
        }
        if (this._appConfigService.getContentServiceConfig() && this._appConfigService.getContentServiceConfig().staticBaseUrl) {
            baseUrl = isPlatformServer(this._platformId) ? baseUrl
                : this._appConfigService.getContentServiceConfig().staticBaseUrl;
        }
        return baseUrl;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentStaticService, deps: [{ token: i1.HttpClient }, { token: i2.AppConfigService }, { token: HttpConfigService }, { token: ContentStorageService }, { token: i0.TransferState }, { token: PLATFORM_ID }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentStaticService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentStaticService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i2.AppConfigService }, { type: HttpConfigService }, { type: ContentStorageService }, { type: i0.TransferState }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }] });

class E2eHelper {
    constructor() {
        this.hashAlgo = 'HmacSHA256';
        this.preMasterSecLen = 128;
        this.bufferSeconds = -30; //buffer 30 seconds
        this.offset = -5.0; // Central Time Zone
    }
    getEventID() {
        return this.eventID;
    }
    clearEventID() {
        this.eventID = null;
        this.e2eBizToken = null;
    }
    getiv() {
        return this.iv;
    }
    gethKey() {
        return this.hKey;
    }
    getCR() {
        return this.CR;
    }
    geteKey() {
        return this.eKey;
    }
    setOldTimeStamp(lastEncryptedDateTime) {
        this.oldTimeStamp = lastEncryptedDateTime;
    }
    getOldTimeStamp() {
        return this.oldTimeStamp;
    }
    gete2eBizToken() {
        return this.e2eBizToken;
    }
    sete2eBizToken(bizToken) {
        this.e2eBizToken = bizToken;
    }
    setLogPreEventid(eventid) {
        this.log_PreEventid = eventid;
    }
    getLogPreEventid() {
        return this.log_PreEventid;
    }
    clearLogPreEventid() {
        this.log_PreEventid = "";
    }
    refreshE2EKeys(new_event_id, encrpExpiry_Time, bizToken) {
        if (new_event_id.indexOf(".") > 1) {
            console.log("ss_old_evnt_1_", this.eventID);
            console.log("ss_new_evnt_2_", new_event_id);
            console.log("ss_new_evnt_expiry_3_", encrpExpiry_Time);
            if (this.eventID || this.eventID != new_event_id) {
                this.clearOldTimestamp();
                this.eventID = new_event_id;
                this.encrypExpireTime = encrpExpiry_Time;
                this.e2eBizToken = bizToken;
                this.setNewEventExpiry();
            }
        }
    }
    generateCheckDigit(encryptionkey) {
        try {
            const dataToEnc = ' ', checDigitLen = 6, paddingLen = 16, padDataToEnc = this.padMsgString(dataToEnc, paddingLen), encData = encrypt(padDataToEnc, CryptoJS_EncHex.parse(encryptionkey), {
                iv: CryptoJS_EncHex.parse(this.iv),
                padding: CryptoJS_NoPad
            }), encDataInHex = encData.ciphertext.toString(CryptoJS_EncHex);
            return encDataInHex.substring(0, checDigitLen);
        }
        catch (e) {
            throw new Error('Error occured while creating check digit');
        }
    }
    // This method can be replaced once string.padEnd() is available in typescript
    padMsgString(msg, padLen) {
        const paddingChar = ' ';
        for (let i = 0; i < padLen; i++) {
            msg += paddingChar;
        }
        return msg;
    }
    // This method is used to create Client Random of 32 bytes
    generateCR() {
        this.CR = this.getSecureRandomHex(16);
        return this.CR;
    }
    clearOldTimestamp() {
        this.oldTimeStamp = null;
    }
    checkOTSisValid() {
        if (this.oldTimeStamp) {
            const currentDateTime = this.getCTDateTime();
            const oldTime = new Date(this.oldTimeStamp);
            oldTime.setSeconds(1);
            console.log("ss__OTS_oldTimeStamp__", oldTime);
            console.log("ss__OTS_currentDateTime__", currentDateTime);
            if (oldTime > currentDateTime) {
                return true;
            } // not to generate new keys
            else {
                return false;
            } // generate new keys
        }
        else {
            return false;
        } // generate new keys
    }
    checkEventIDTimeisValid() {
        const decrpExpiryTime = this.eventIDExpiryDtTime;
        if (decrpExpiryTime) {
            const clientCurDate = this.getCTDateTime();
            console.log("ss_chk_curDt_", clientCurDate);
            console.log("ss_chk_decrpDt_", decrpExpiryTime);
            if (decrpExpiryTime > clientCurDate) {
                return true;
            }
            else if (decrpExpiryTime < clientCurDate) {
                return this.checkOTSisValid();
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    setNewEventExpiry() {
        const expiryTime = this.encrypExpireTime;
        if (expiryTime) {
            if (!this.iv) {
                this.randomValues();
            }
            const expTime = rs.b64nltohex(expiryTime);
            let decryptedSeconds = this.decryptDataWithAesKey(expTime);
            const clientDate = this.getCTDateTime();
            console.log("ss_Current_CT_DateTime_", clientDate);
            console.log("ss_decryptedSeconds_", decryptedSeconds);
            // 30 seconds is of buffer time
            if (decryptedSeconds == "") {
                decryptedSeconds = "1200";
            }
            clientDate.setSeconds(parseInt(decryptedSeconds) + this.bufferSeconds);
            this.eventIDExpiryDtTime = clientDate;
            console.log("ss_set_eventIDExpiryDtTime_", this.eventIDExpiryDtTime);
        }
    }
    getCTDateTime() {
        const timeObject = new Date(), utc = timeObject.getTime() + (timeObject.getTimezoneOffset() * 60000), ctDateTime = new Date(utc + 3600000 * this.offset);
        return ctDateTime;
    }
    randomValues() {
        const preMasterSec = this.getSecureRandomHex(this.preMasterSecLen), salt = preMasterSec.substring(0, 64), ek_ikm = preMasterSec.substring(64, 128), iv_ikm = preMasterSec.substring(128, 192), hk_ikm = preMasterSec.substring(192, 256);
        this.iv = this.getHMAC256Hash(iv_ikm, salt).substring(0, 32);
        this.eKey = this.getHMAC256Hash(ek_ikm, salt);
        this.hKey = this.getHMAC256Hash(hk_ikm, salt);
        this.CR = this.generateCR();
    }
    getHMAC256Hash(dataToHash, hashKey) {
        // handle error scenaio while creating hash
        const mac = new rs.KJUR.crypto.Mac({
            alg: this.hashAlgo,
            pass: { hex: hashKey }
        });
        mac.updateHex(dataToHash);
        const macHex = mac.doFinal();
        return macHex;
    }
    // This function creates a secure random hex string of given bytes
    getSecureRandomHex(n) {
        return rs.crypto.Util.getRandomHexOfNbytes(n);
    }
    decryptDataWithAesKey(encData) {
        // Assumption encData will be in Hex
        try {
            const decData = decrypt({ ciphertext: CryptoJS_EncHex.parse(encData) }, CryptoJS_EncHex.parse(this.eKey), {
                iv: CryptoJS_EncHex.parse(this.iv)
            }).toString(Utf8);
            return decData;
        }
        catch (e) {
            console.error('Error occured while decrypting data with AES Key', e);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: E2eHelper, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: E2eHelper, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: E2eHelper, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

const ShapeErrorHandler = (error) => {
    // Define shape error handler
    // console.log("shape error handler...", error)
    if (error.status === 429) {
        const tmpBody = error.error || '';
        const body = tmpBody || JSON.stringify(tmpBody);
        // console.log('shapeErrorHandler body...', body);
        if (body.code === 'ER001') {
            // navigate to body location
            window.location.href = body.location;
        }
        else if (body.code === 'ER002') {
            // navigate to sign off
            let destUrl = window.location.protocol + '//' + window.location.host + '/US/ag/sign-off';
            window.location.href = destUrl;
        }
    }
    return throwError(error);
};
// export const HttpErrorHandlerE2E = (
//   error: HttpErrorResponse
//   ): Observable<HttpErrorResponse> => {
//     let e2helper = new E2eHelper; //remove this
//     // Define e2e error handler
//     e2helper.clearOldTimestamp();
//     if(error.headers.has('eventid')){
//       e2helper.refreshE2EKeys(error.headers.get('eventid'),  error.headers.get('eventidexpirytime'), error.headers.get('bizToken'));
//     }
//     return throwError(error);
// }
/**
* The HttpService provides http request behavior.
*
* Declare httpService object {HttpServiceConfig} in Application Config
* <pre>
* httpService: {
*   defaultHeaders: {
*    headerName: string;
*    headerValue: string;
*   },
*  headersToSendFromPreviousResponse: [
*     {
*       headerNameInPreviousResponse: string,
*       headerNameToSendInRequest: string
*     }
*   ]
* }
* </pre>
*
* It also uses the information in the sessionCookieInformation object
* <pre>
* sessionCookieInformation: {
*   cookieName: string[];
*   valueSeparator: string;
*   headers: [
*     {
*       headerName: string;
*       headerValue: string;
*     }
*   ];
* }
* </pre>
*  HttpService
*
*/
class HttpService {
    /**** DONT ADDED any NEW classes on the CONSTRUCTOR its been refered on rewards flow, if needed just pass it as optional parameter ****/
    constructor(_httpClient, _appConfigService, _storageService, _contentStorageService, _contentStaticService, _httpConfigService, _platformId, _e2eHelper, _postSignoffService) {
        this._httpClient = _httpClient;
        this._appConfigService = _appConfigService;
        this._storageService = _storageService;
        this._contentStorageService = _contentStorageService;
        this._contentStaticService = _contentStaticService;
        this._httpConfigService = _httpConfigService;
        this._platformId = _platformId;
        this._e2eHelper = _e2eHelper;
        this._postSignoffService = _postSignoffService;
        this.headersToSendFromPreviousResponse = [
            {
                headerNameInPreviousResponse: 'CCPToken',
                headerNameToSendInRequest: 'CCPToken'
            },
            {
                headerNameInPreviousResponse: 'citi_authorization',
                headerNameToSendInRequest: 'citi_authorization',
                deleteOnAppLoad: true,
                setToService: true
            }
        ];
        this.headersToSaveFromResponse = ['CCPToken'];
        this._globalErrorHandlers = {};
        this.newSessionDeleteLogic = false;
        /**
         * The DemotedErrorHandler method add the {HttpServiceErrorHandler}
         * When an error with status code of 401 occurs, the HttpService will execute all the error handlers with calling deleteSessionTokens.
         */
        this.DemotedErrorHandler = (error) => {
            // Define demoted error handler
            // console.log("demoted error handler...", error)
            if (error.status === 401 && !Cookie.get('isLoggedIn')) {
                console.log("Pre login failure case for token expiry - demotedCustomerSignoff");
                this.deleteSessionTokens();
                //taking user back to homepage
                window.location.href = this._appConfigService.getConfig('sessionService').sessionTimeoutUrl;
            }
            return throwError(error);
        };
        this.newSessionDeleteLogic = !!this._appConfigService.getSessionDeleteFlagConfig();
    }
    // CAP-Changes Story# GBC-7605
    deleteSessionTokens() {
        try {
            const options = { headers: { tenantId: 'tenantId', errorPage: 'errorPage' } };
            this.delete(`/digital/security/auth/demotedCustomerSignoff`, options).pipe(catchError(error => of([]))).subscribe();
            // Adding isLoggedIn cookie entry for February Cookie Updates
            const cookiesToDelete = ['Authorization', 'bizToken', 'isLoggedIn'];
            for (const cookieKey of cookiesToDelete) {
                console.log('Cookie delete from citi-http: ', Cookie.get(cookieKey));
                Cookie.delete(cookieKey, '/');
                Cookie.delete(cookieKey, '/', '.citi.com');
            }
            return true;
        }
        catch (e) {
            return false;
        }
    }
    // CAP-Changes Story# GBC-7605
    async deleteSessions(clearStorage) {
        //optional params for teams to pass in order to clear storage
        if (clearStorage) {
            this._postSignoffService.clearCookiesAndSessionStorage();
        }
        const options = { headers: { tenantId: 'tenantId', errorPage: 'errorPage' } };
        return await this.delete(`/digital/security/auth/demotedCustomerSignoff`, options).toPromise().then(() => {
            return true;
        }).catch(() => {
            return false;
        });
    }
    clearSessionTokens() {
        try {
            this.bizTokenResponse = null;
            this.authorizationResponse = null;
            this.citiAuthorizationResponse = null;
            this._e2eHelper.clearEventID();
            return true;
        }
        catch (e) {
            return false;
        }
    }
    getSessionTokens() {
        return {
            bizToken: this.bizTokenResponse,
            citi_authorization: this.citiAuthorizationResponse,
            authorization: this.authorizationResponse
        };
    }
    /**
     * The addGlobalErrorHandler method add the {HttpServiceErrorHandler}
     * When an error occurs, the HttpService will execute all the error handlers added.
     *  addGlobalErrorHandler
     *
     *  idErrorHandler {string} Id associated to the error handler. This is needed in order to avoid adding more than once the same handler if the component if re painted.
     *  httpServiceErrorHandler {HttpServiceErrorHandler} The global error handler to add.
     *  {void}
     */
    addGlobalErrorHandler(idErrorHandler, httpServiceErrorHandler) {
        this._globalErrorHandlers[idErrorHandler] = httpServiceErrorHandler;
    }
    removeGlobalErrorHandler(handlerName) {
        try {
            delete this._globalErrorHandlers[handlerName];
            return true;
        }
        catch (e) {
            console.error(this.constructor.name, new Date(), '\n', `problem removing error handler :: ${handlerName}`);
            return false;
        }
    }
    getGlobalErrorHandlers() {
        return Object.keys(this._globalErrorHandlers);
    }
    /**
     * The get method is used to send a HTTP GET request.
     *
     * HttpService will add the defaultHeaders from HttpServiceConfig in Application Config.
     *
     * The property headersToSendFromResponse will be used to send headers that come in an http response.
     * HttpService will save from all the responses, the header with the name headerNameInResponse in the local storage.
     * Then in the next request, it will send that value in a header request with the name specified in headerNameToSendInRequest.
     *
     * The HttpService will create the headers declared in cookieValuesHeaders from sessionCookieInformation config object.
     * It will take the value from the cookie using cookieName, and create an array of strings using the valueSeparator to split the values.
     * If valueSeparator is not specified it will create an array with only one string which is the value of the cookie.
     * Then it will create all the headers specified in the headers array. Using headerName as the name of the header, and using headerValue as the value of the header.
     * headerValue can contain place holders, like [0], [1], [2], etc. Where [n] is the the index of the array of values.
     * The placeholder will be replaced for the value in the array for the index specified.
     *
     *  get
     *
     *  url {string} The url path where to send the request. If the url is relative (does not contain http:// or https:// ), it will be appended to the apiServerUrl property from Application Config.
     * options {object} Params object to send in the request.
     *  {Observable<any>}
     */
    get(url, options, successHandler, errorHandler, responseHeaders, aemContentCall) {
        if (typeof options === 'function') {
            errorHandler = successHandler;
            successHandler = options;
            options = {};
        }
        if (typeof options === 'undefined' || options === null) {
            options = {};
        }
        let observable;
        let timeout$1;
        if (options.timeout) {
            timeout$1 = options.timeout;
        }
        else {
            timeout$1 = this._appConfigService.getHttpServiceConfig().timeout;
        }
        let getStaticContent = true;
        if (typeof options.getStaticContent === 'boolean') {
            getStaticContent = options.getStaticContent;
        }
        const customOptions = aemContentCall ? { observe: 'response' } : this.updateOptions(options);
        if (timeout$1) {
            observable = this._httpClient
                .get(this.getUrl(url), customOptions)
                .pipe(timeout(timeout$1 * 1000), mergeMap((data) => responseHeaders ? this.extractData(data, getStaticContent, responseHeaders) : this.extractData(data, getStaticContent)));
        }
        else {
            observable = this._httpClient
                .get(this.getUrl(url), customOptions)
                .pipe(mergeMap((data) => responseHeaders ? this.extractData(data, getStaticContent, responseHeaders) : this.extractData(data, getStaticContent)));
        }
        observable = this.addErrorHandlersToObservable(observable);
        if (errorHandler) {
            observable = observable.pipe(catchError(errorHandler));
        }
        if (successHandler) {
            observable.subscribe(successHandler);
        }
        return observable;
    }
    delete(url, options, successHandler, errorHandler) {
        if (typeof options === 'function') {
            errorHandler = successHandler;
            successHandler = options;
            options = {};
        }
        if (typeof options === 'undefined' || options === null) {
            options = {};
        }
        let observable;
        let timeout$1;
        if (options.timeout) {
            timeout$1 = options.timeout;
        }
        else {
            timeout$1 = this._appConfigService.getHttpServiceConfig().timeout;
        }
        let getStaticContent = true;
        if (typeof options.getStaticContent === 'boolean') {
            getStaticContent = options.getStaticContent;
        }
        if (timeout$1) {
            observable = this._httpClient
                .delete(this.getUrl(url), this.updateOptions(options))
                .pipe(timeout(timeout$1 * 1000), mergeMap((data) => this.extractData(data, getStaticContent)));
        }
        else {
            observable = this._httpClient
                .delete(this.getUrl(url), this.updateOptions(options))
                .pipe(mergeMap((data) => this.extractData(data, getStaticContent)));
        }
        observable = this.addErrorHandlersToObservable(observable);
        if (errorHandler) {
            observable = observable.pipe(catchError(errorHandler));
        }
        if (successHandler) {
            observable.subscribe(successHandler);
        }
        return observable;
    }
    /**
     * The post method is used to send a HTTP POST request.
     *
     * HttpService will add the defaultHeaders from HttpServiceConfig in Application Config.
     *
     * The property headersToSendFromResponse will be used to send headers that come in an http response.
     * HttpService will save from all the responses, the header with the name headerNameInResponse in the local storage.
     * Then in the next request, it will send that value in a header request with the name specified in headerNameToSendInRequest.
     *
     * The HttpService will create the headers declared in cookieValuesHeaders from sessionCookieInformation config object.
     * It will take the value from the cookie using cookieName, and create an array of strings using the valueSeparator to split the values.
     * If valueSeparator is not specified it will create an array with only one string which is the value of the cookie.
     * Then it will create all the headers specified in the headers array. Using headerName as the name of the header, and using headerValue as the value of the header.
     * headerValue can contain place holders, like [0], [1], [2], etc. Where [n] is the the index of the array of values.
     * The placeholder will be replaced for the value in the array for the index specified.
     *
     *  post
     * public
     * param url {string} The url path where to send the request. If the url is relative (does not contain http:// or https:// ), it will be appended to the apiServerUrl property from Application Config.
     * aram body {object} Body object to send in the request.
     * aram options {object} Params object to send in the request.
     * returns {Observable<any>}
     */
    post(url, body, options, successHandler, errorHandler, responseHeaders) {
        if (typeof body === 'function') {
            errorHandler = options;
            successHandler = body;
            options = {};
            body = {};
        }
        if (typeof options === 'function') {
            errorHandler = successHandler;
            successHandler = options;
            options = {};
        }
        if (typeof options === 'undefined' || options === null) {
            options = {};
        }
        let observable;
        let timeout$1;
        if (options.timeout) {
            timeout$1 = options.timeout;
        }
        else {
            timeout$1 = this._appConfigService.getHttpServiceConfig().timeout;
        }
        let getStaticContent = true;
        if (typeof options.getStaticContent === 'boolean') {
            getStaticContent = options.getStaticContent;
        }
        if (timeout$1) {
            observable = this._httpClient
                .post(this.getUrl(url), body, this.updateOptions(options))
                .pipe(timeout(timeout$1 * 1000), flatMap((data) => responseHeaders ? this.extractData(data, getStaticContent, responseHeaders) : this.extractData(data, getStaticContent)));
        }
        else {
            observable = this._httpClient
                .post(this.getUrl(url), body, this.updateOptions(options))
                .pipe(flatMap((data) => responseHeaders ? this.extractData(data, getStaticContent, responseHeaders) : this.extractData(data, getStaticContent)));
        }
        observable = this.addErrorHandlersToObservable(observable);
        if (errorHandler) {
            observable = observable.pipe(catchError(errorHandler));
        }
        if (successHandler) {
            observable.subscribe(successHandler);
        }
        return observable;
    }
    /**
     * The put method is used to send a HTTP PUT request.
     *
     * HttpService will add the defaultHeaders from HttpServiceConfig in Application Config.
     *
     * The property headersToSendFromResponse will be used to send headers that come in an http response.
     * HttpService will save from all the responses, the header with the name headerNameInResponse in the local storage.
     * Then in the next request, it will send that value in a header request with the name specified in headerNameToSendInRequest.
     *
     * The HttpService will create the headers declared in cookieValuesHeaders from sessionCookieInformation config object.
     * It will take the value from the cookie using cookieName, and create an array of strings using the valueSeparator to split the values.
     * If valueSeparator is not specified it will create an array with only one string which is the value of the cookie.
     * Then it will create all the headers specified in the headers array. Using headerName as the name of the header, and using headerValue as the value of the header.
     * headerValue can contain place holders, like [0], [1], [2], etc. Where [n] is the the index of the array of values.
     * The placeholder will be replaced for the value in the array for the index specified.
     *
     * method put
     * public
     * param url {string} The url path where to send the request. If the url is relative (does not contain http:// or https:// ), it will be appended to the apiServerUrl property from Application Config.
     * param body {object} Body object to send in the request.
     * param options {object} Params object to send in the request.
     * returns {Observable<any>}
     */
    put(url, body, options, successHandler, errorHandler) {
        if (typeof body === 'function') {
            errorHandler = options;
            successHandler = body;
            options = {};
            body = {};
        }
        if (typeof options === 'function') {
            errorHandler = successHandler;
            successHandler = options;
            options = {};
        }
        if (typeof options === 'undefined' || options === null) {
            options = {};
        }
        let observable;
        let timeout$1;
        if (options.timeout) {
            timeout$1 = options.timeout;
        }
        else {
            timeout$1 = this._appConfigService.getHttpServiceConfig().timeout;
        }
        let getStaticContent = true;
        if (typeof options.getStaticContent === 'boolean') {
            getStaticContent = options.getStaticContent;
        }
        if (timeout$1) {
            observable = this._httpClient
                .put(this.getUrl(url), body, this.updateOptions(options))
                .pipe(timeout(timeout$1 * 1000), mergeMap((data) => this.extractData(data, getStaticContent)));
        }
        else {
            observable = this._httpClient
                .put(this.getUrl(url), body, this.updateOptions(options))
                .pipe(mergeMap(data => this.extractData(data, getStaticContent)));
        }
        observable = this.addErrorHandlersToObservable(observable);
        if (errorHandler) {
            observable = observable.pipe(catchError(errorHandler));
        }
        if (successHandler) {
            observable.subscribe(successHandler);
        }
        return observable;
    }
    updateOptions(options) {
        let optionRes = this._httpConfigService.getOptions(options);
        if (this.headersToSendFromPreviousResponse) {
            for (let headerInfo of this.headersToSendFromPreviousResponse) {
                if (headerInfo.headerNameInPreviousResponse == 'bizToken' &&
                    !!this.bizTokenResponse) {
                    optionRes.headers = optionRes.headers.set(headerInfo.headerNameToSendInRequest, this.bizTokenResponse);
                }
                else if (headerInfo.headerNameInPreviousResponse == 'Authorization' &&
                    !!this.authorizationResponse) {
                    let value = 'Bearer ' + this.authorizationResponse;
                    optionRes.headers = optionRes.headers.set(headerInfo.headerNameToSendInRequest, value);
                }
                else if (headerInfo.headerNameInPreviousResponse == 'citi_authorization' &&
                    !!this.citiAuthorizationResponse) {
                    optionRes.headers = optionRes.headers.set(headerInfo.headerNameToSendInRequest, this.citiAuthorizationResponse);
                }
            }
        }
        return optionRes;
    }
    getUrl(url) {
        if (url.indexOf('http://') > -1 || url.indexOf('https://') > -1) {
            return url;
        }
        else if (this._appConfigService.getApiServerUrl()) {
            return this._appConfigService.getApiServerUrl() + url;
        }
        return url;
    }
    extractData(res, getStaticContent, responseHeaders) {
        let body;
        body = res && res.body ? res.body : {};
        // if (res === '') {
        //   body = {};
        // } else {
        //   body = res;
        // }
        // //Save headers in session storage
        // if (this._appConfigService.getHttpServiceConfig().headersToSendFromPreviousResponse) {
        //     for (let headerInfo of this._appConfigService.getHttpServiceConfig().headersToSendFromPreviousResponse) {
        //         if (res.headers.has(headerInfo.headerNameInPreviousResponse)) {
        //             this._storageService.set(headerInfo.headerNameInPreviousResponse, res.headers.get(headerInfo.headerNameInPreviousResponse));
        //         }
        //     };
        // }
        // debugger;
        // console.log('res should be type HTTPResponse: -- > ', res);
        // Save headers in session storage
        // if (
        //   this._appConfigService.getHttpServiceConfig().headersToSaveFromResponse
        // ) {
        //   for (let headerName of this._appConfigService.getHttpServiceConfig()
        //     .headersToSaveFromResponse) {
        //     if (res && res.headers && res.headers.has(headerName)) {
        //       this._storageService.set(headerName, res.headers.get(headerName));
        //     }
        //   }
        // }
        if (this.headersToSendFromPreviousResponse) {
            for (let headerInfo of this.headersToSendFromPreviousResponse) {
                if (res.headers.has(headerInfo.headerNameInPreviousResponse) &&
                    headerInfo.setToService) {
                    if (headerInfo.headerNameInPreviousResponse == 'Authorization') {
                        this.authorizationResponse = res.headers.get(headerInfo.headerNameInPreviousResponse);
                    }
                    else if (headerInfo.headerNameInPreviousResponse == 'bizToken') {
                        this.bizTokenResponse = res.headers.get(headerInfo.headerNameInPreviousResponse);
                    }
                    else if (headerInfo.headerNameInPreviousResponse == 'citi_authorization') {
                        this.citiAuthorizationResponse = res.headers.get(headerInfo.headerNameInPreviousResponse);
                    }
                }
            }
        }
        this._e2eHelper.clearOldTimestamp();
        let uuid = res.headers.get('uuid');
        if (res.headers.has('eventid')) {
            this._e2eHelper.refreshE2EKeys(res.headers.get('eventid'), res.headers.get('eventidexpirytime'), res.headers.get('bizToken'));
        }
        else if (uuid && this._e2eHelper.getLogPreEventid() && res.url && res.url.indexOf('userInterface/errorLogging') === -1) {
            //DRR-29160
            this._e2eHelper.clearLogPreEventid();
        }
        //Save headers in session storage
        if (this.headersToSaveFromResponse) {
            for (let headerName of this.headersToSaveFromResponse) {
                if (res.headers.has(headerName)) {
                    this._storageService.set(headerName, res.headers.get(headerName));
                }
            }
        }
        if (getStaticContent) {
            if (body && body['content']) {
                let dynamicContent = body['content'];
                let bundles = Object.keys(dynamicContent);
                if (bundles !== null && bundles.length > 0) {
                    let bundleName = bundles[0];
                    this._contentStorageService.set(bundleName, dynamicContent[bundleName]);
                    return this._contentStaticService.getStaticBundle(bundleName).pipe(map(contentData => {
                        body['content'] = contentData;
                        return body;
                    }));
                }
            }
        }
        if (responseHeaders) {
            return of(res || {});
        }
        else {
            return of(body || {});
        }
    }
    addErrorHandlersToObservable(observable) {
        if (this._globalErrorHandlers &&
            Object.keys(this._globalErrorHandlers).length === 0) {
            observable = observable.pipe(catchError(this.defaultErrorHandler));
        }
        else {
            for (let idErrorHandler of Object.keys(this._globalErrorHandlers)) {
                observable = observable.pipe(catchError(this._globalErrorHandlers[idErrorHandler]));
            }
        }
        return observable;
    }
    defaultErrorHandler(error) {
        const body = error || '';
        let errMsg = `HttpService: ${error.status} - ${error.statusText ||
            ''} ${body}`;
        console.error(errMsg);
        return throwError(error);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HttpService, deps: [{ token: i1.HttpClient }, { token: i2.AppConfigService }, { token: i2.StorageService }, { token: ContentStorageService }, { token: ContentStaticService }, { token: HttpConfigService }, { token: PLATFORM_ID }, { token: E2eHelper }, { token: i2.PostSignoffService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HttpService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HttpService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i2.AppConfigService }, { type: i2.StorageService }, { type: ContentStorageService }, { type: ContentStaticService }, { type: HttpConfigService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: E2eHelper }, { type: i2.PostSignoffService }] });

class ContentService {
    constructor(_httpService, _appConfigService, _transferState, _contentStaticService, _contentStorageService, _platformId) {
        this._httpService = _httpService;
        this._appConfigService = _appConfigService;
        this._transferState = _transferState;
        this._contentStaticService = _contentStaticService;
        this._contentStorageService = _contentStorageService;
        this._platformId = _platformId;
    }
    get(appId, contentType, contentId, prop, placeholdersObj) {
        return this._contentStorageService.get(appId, contentType, contentId, prop, placeholdersObj);
    }
    /**
     *
     * @param appId -
     * @param contentType - type of content type to be returned
     * @param contentId - your content ID
     * @param requestOptions - represents any additional HTTP options to be passed along with the content call; userful
     * for overriding default HTTP configurations
     */
    makeApiCall(appId, contentType, contentId, requestOptions) {
        if (!requestOptions || typeof requestOptions != 'object') {
            requestOptions = {};
        }
        requestOptions = Object.assign(requestOptions, { getStaticContent: false });
        let baseUrl = '';
        if (this._appConfigService.getApiServerUrl()) {
            baseUrl = this._appConfigService.getApiServerUrl();
        }
        if (this._appConfigService.getContentServiceConfig() &&
            this._appConfigService.getContentServiceConfig().contentApiBaseUrl) {
            baseUrl = this._appConfigService.getContentServiceConfig().contentApiBaseUrl;
        }
        let url = baseUrl +
            '/content/subBusinessID/' +
            this._appConfigService.getBusinessId() +
            '/applicationID/' +
            appId +
            '/contentType/' +
            contentType +
            '/contentID/' +
            contentId;
        return this._httpService
            .get(url, requestOptions)
            .pipe(flatMap(data => this.saveData(data, appId, contentType, contentId)));
    }
    getStaticBundle(appId, customBusinessLogic) {
        return this._contentStaticService.getStaticBundle(appId, customBusinessLogic);
    }
    getPageDef(appId, viewId) {
        return this._contentStaticService.getPageDef(appId, viewId);
    }
    getStaticResource(path) {
        this._contentStaticService.getStaticResource(path);
    }
    saveData(data, appId, contentType, contentId) {
        let returnObj = {};
        if (data && data['content']) {
            this._contentStorageService.set(appId, data['content'][appId]);
            returnObj = this._contentStorageService.get(appId, contentType, contentId);
        }
        return of(returnObj);
    }
    //AEM Methods for journey team cobsumption.
    getAemContent(urlPath, responseHeaders) {
        return this.makeAEMContentCall(urlPath, responseHeaders);
    }
    makeAEMContentCall(urlPath, responseHeaders) {
        this.aemEnvironmentConfig = this._appConfigService.getAEMConfig();
        urlPath = urlPath.replace(/{locale}/g, this._appConfigService.getLocale() === 'es_US' ? 'es' : 'en');
        const isServer = isPlatformServer(this._platformId);
        const serverSideUrl = this.buildAEMContentURL(urlPath, true);
        const key = makeStateKey('aemCS' + serverSideUrl);
        if (isServer) {
            return this._httpService.get(serverSideUrl, null, null, null, responseHeaders, true).pipe(flatMap(response => {
                this._transferState.set(key, response);
                return of(response);
            }));
        }
        else {
            const storedResponse = this._transferState.get(key, null);
            return storedResponse
                ? of(storedResponse)
                : this._httpService.get(this.buildAEMContentURL(urlPath, false), null, null, null, responseHeaders, true);
        }
    }
    buildAEMContentURL(urlPath, isServer) {
        console.log("Inside buildAEMContentURL");
        console.log("isServer : ", isServer);
        let contentUrl = '';
        contentUrl = isServer ? this.aemEnvironmentConfig?.aemContentServiceUrl : this.aemEnvironmentConfig?.aemServerUrl;
        contentUrl += isServer ?
            "/prelogin/aem/contentorches/graphql/" :
            "/graphql/execute.json/";
        contentUrl += urlPath;
        console.log("In contentCall.resolver.ts - AEM Content URL: ", contentUrl);
        return contentUrl;
    }
    cleanUpKey(requestUrl) {
        let baseUrl = this._appConfigService.getApiServerUrlPlatformServer() ?? '';
        return requestUrl.replace(baseUrl, '');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentService, deps: [{ token: HttpService }, { token: i2.AppConfigService }, { token: i0.TransferState }, { token: ContentStaticService }, { token: ContentStorageService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpService }, { type: i2.AppConfigService }, { type: i0.TransferState }, { type: ContentStaticService }, { type: ContentStorageService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }] });

class ContentResolve {
    constructor(_cs, _router, _appConfigService) {
        this._cs = _cs;
        this._router = _router;
        this._appConfigService = _appConfigService;
    }
    resolve(route, routerStateSnapshot) {
        let appId = route.data['appId'];
        let contentType = route.data['contentType'];
        let contentId = route.data['contentId'];
        const self = this;
        if (appId && contentType && contentId) {
            return this._cs.makeApiCall(appId, contentType, contentId).pipe(catchError((error) => {
                if (self._appConfigService.getContentServiceConfig()
                    .routeOnContentResolveError) {
                    self._router.navigate([
                        self._appConfigService.getContentServiceConfig()
                            .routeOnContentResolveError
                    ]);
                }
                return of({});
            }));
        }
        else if (appId) {
            return this._cs.getStaticBundle(appId).pipe(catchError((error) => {
                if (self._appConfigService.getContentServiceConfig()
                    .routeOnContentResolveError) {
                    self._router.navigate([
                        self._appConfigService.getContentServiceConfig()
                            .routeOnContentResolveError
                    ]);
                }
                return of({});
            }));
        }
        else {
            return of({});
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentResolve, deps: [{ token: ContentService }, { token: i2$1.Router }, { token: i2.AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentResolve }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentResolve, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: ContentService }, { type: i2$1.Router }, { type: i2.AppConfigService }] });

class HttpInterceptorService {
    constructor(_appConfigService, _transferState, _platformId) {
        this._appConfigService = _appConfigService;
        this._transferState = _transferState;
        this._platformId = _platformId;
    }
    intercept(request, next) {
        // // interceptor for http vs httclient;
        // console.log('this is the request options', request);
        // if (request.responseType === 'json') {
        //   let newRequest = request.clone({ responseType: 'text' });
        //   return next.handle(newRequest);
        // }
        if (request.method !== 'GET') {
            return next.handle(request);
        }
        const key = makeStateKey(this.cleanUpKey(request.url));
        if (isPlatformServer(this._platformId)) {
            return next.handle(request).pipe(tap(event => {
                this._transferState.set(key, event.body);
            }));
        }
        else {
            const storedResponse = this._transferState.get(key, null);
            //not to call the e2e get methods
            if (storedResponse && key.indexOf("e2e") == -1) {
                const response = new HttpResponse({
                    body: storedResponse,
                    status: 200
                });
                // this._transferState.remove(key);
                return of(response);
            }
            else
                return next.handle(request);
        }
    }
    cleanUpKey(requestUrl) {
        let baseUrl = this._appConfigService.getApiServerUrl() ?? '';
        return requestUrl.replace(baseUrl, '');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HttpInterceptorService, deps: [{ token: i2.AppConfigService }, { token: i0.TransferState }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HttpInterceptorService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HttpInterceptorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i2.AppConfigService }, { type: i0.TransferState }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }] });

class ContentComponent {
    constructor(_contentService) {
        this._contentService = _contentService;
    }
    getContent() {
        if (this.appId) {
            return this._contentService.get(this.appId, this.contentType, this.contentId, this.prop, this.placeholders);
        }
        else {
            return this._contentService.get(this.bundleName, this.contentType, this.contentId, this.prop, this.placeholders);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentComponent, deps: [{ token: ContentService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: ContentComponent, isStandalone: false, selector: "content", inputs: { appId: "appId", bundleName: "bundleName", contentType: "contentType", contentId: "contentId", prop: "prop", placeholders: "placeholders" }, ngImport: i0, template: "{{ getContent() }}\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'content', standalone: false, template: "{{ getContent() }}\n" }]
        }], ctorParameters: () => [{ type: ContentService }], propDecorators: { appId: [{
                type: Input
            }], bundleName: [{
                type: Input
            }], contentType: [{
                type: Input
            }], contentId: [{
                type: Input
            }], prop: [{
                type: Input
            }], placeholders: [{
                type: Input
            }] } });

/**
 * @module CorePlatformRoutingModule
 * @main CorePlatformRoutingModule
 **/
/** CorePlatformRoutingModule **/
/**
 * The NoContentComponent
 * class NoContentComponent
 **/
class PageNotFoundComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: PageNotFoundComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: PageNotFoundComponent, isStandalone: false, selector: "ng-component", ngImport: i0, template: "<div>\n  <h1>Page Not Found</h1>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: PageNotFoundComponent, decorators: [{
            type: Component,
            args: [{ standalone: false, template: "<div>\n  <h1>Page Not Found</h1>\n</div>\n" }]
        }] });

class ContentModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: ContentModule, declarations: [ContentComponent, PageNotFoundComponent], imports: [CommonModule, RouterModule], exports: [ContentComponent, PageNotFoundComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentModule, imports: [CommonModule, RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule],
                    declarations: [ContentComponent, PageNotFoundComponent],
                    exports: [ContentComponent, PageNotFoundComponent]
                }]
        }] });

class HTTPRequestInterceptor {
    constructor(appConfigService) {
        this.appConfigService = appConfigService;
    }
    intercept(req, next) {
        // adding the accept-language header in every http-request
        const customReq = req.clone({
            headers: req.headers.set('Accept-language', this.appConfigService.getLocale())
        });
        return next.handle(customReq).pipe(catchError(error => {
            return throwError(error);
        }), finalize(() => {
            console.log('request intercepted successfully');
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HTTPRequestInterceptor, deps: [{ token: i2.AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HTTPRequestInterceptor, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HTTPRequestInterceptor, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i2.AppConfigService }] });

class ApiUrlInterceptor {
    constructor(_appConfigService) {
        this._appConfigService = _appConfigService;
    }
    intercept(req, next) {
        const newReq = req.clone({
            url: this.getUrl(req.url)
        });
        return next.handle(newReq);
    }
    getUrl(url) {
        if (url.indexOf('http://') > -1 || url.indexOf('https://') > -1) {
            return url;
        }
        if (url.startsWith('/CBOL/IA')) {
            return url;
        }
        if (this._appConfigService.getApiServerUrl()) {
            return this._appConfigService.getApiServerUrl() + url;
        }
        return url;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ApiUrlInterceptor, deps: [{ token: i2.AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ApiUrlInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ApiUrlInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i2.AppConfigService }] });

const HTTP_INTERCEPTOR_PROVIDERS = [
    { provide: HTTP_INTERCEPTORS, useClass: ApiUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: HTTPRequestInterceptor,
        multi: true
    }
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: DefaultHeadersInterceptor,
    //   multi: true
    // }
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: HeadersFromPrevResponseInterceptor,
    //   multi: true
    // }
];

/**
 * Generated bundle index. Do not edit.
 */

export { ContentComponent, ContentModule, ContentResolve, ContentService, ContentStaticService, ContentStorageService, E2eHelper, HTTPRequestInterceptor, HTTP_INTERCEPTOR_PROVIDERS, HttpConfigService, HttpInterceptorService, HttpService, PageNotFoundComponent, ShapeErrorHandler };
